import { render, staticRenderFns } from "./ViAdmissionAddStudent.vue?vue&type=template&id=5e527b9a"
import script from "./ViAdmissionAddStudent.vue?vue&type=script&lang=js"
export * from "./ViAdmissionAddStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports